module.exports = __webpack_public_path__ + "static/media/eye-closed.ecf4d7a5.svg";